var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', [_c('v-card-text', {
    staticClass: "px-4 pt-4 pb-1"
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', [_c('v-select', {
    attrs: {
      "dense": "",
      "items": _vm.edgeTables,
      "label": "Choose edge table",
      "outlined": ""
    },
    model: {
      value: _vm.networkEdgeTable,
      callback: function ($$v) {
        _vm.networkEdgeTable = $$v;
      },
      expression: "networkEdgeTable"
    }
  })], 1)], 1), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', [_c('v-text-field', {
    attrs: {
      "dense": "",
      "error-messages": _vm.networkCreationErrors,
      "label": "Network name",
      "outlined": ""
    },
    model: {
      value: _vm.newNetwork,
      callback: function ($$v) {
        _vm.newNetwork = $$v;
      },
      expression: "newNetwork"
    }
  })], 1)], 1)], 1), _c('v-divider'), _c('v-card-actions', {
    staticClass: "px-4 py-3"
  }, [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "depressed": "",
      "color": "primary",
      "disabled": _vm.networkCreateDisabled || _vm.loading,
      "loading": _vm.loading
    },
    on: {
      "click": _vm.createNetwork
    }
  }, [_vm._v(" create network ")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }